// Importeer React hooks en CSS
import React, { useEffect, useRef, useState } from 'react';
import './custom-cursor.css';

// Definieer de CustomCursor component
const CustomCursor = () => {
  // Maak een referentie naar het HTML element van de cirkel
  const cursorOutline = useRef(null);
  // Sla de huidige muispositie (X) op
  const mouseX = useRef(0);
  // Sla de huidige muispositie (Y) op
  const mouseY = useRef(0);
  // Sla de huidige positie van de cirkel (X) op
  const outlineX = useRef(0);
  // Sla de huidige positie van de cirkel (Y) op
  const outlineY = useRef(0);
  // State voor of de cursor vergroot moet zijn (bij hover)
  const [isHovering, setIsHovering] = useState(false);

  // Voer code uit wanneer de component geladen is
  useEffect(() => {
    // Functie die uitgevoerd wordt wanneer de muis beweegt
    const handleMouseMove = (e) => {
      // Werk de muispositie X bij
      mouseX.current = e.clientX;
      // Werk de muispositie Y bij
      mouseY.current = e.clientY;
    };

    // Functie voor wanneer je over een link/button hovert
    const handleMouseOver = (e) => {
      // Controleer of het element zelf een link of button is
      if (e.target.tagName === 'A' || e.target.tagName === 'BUTTON') {
        // Zet hover state aan
        setIsHovering(true);
      }
    };

    // Functie voor wanneer je van een link/button af gaat
    const handleMouseOut = (e) => {
      // Controleer of het element zelf een link of button is
      if (e.target.tagName === 'A' || e.target.tagName === 'BUTTON') {
        // Zet hover state uit
        setIsHovering(false);
      }
    };

    // Variabele om de animatie frame op te slaan
    let animationFrameId;
    // Functie die iedere frame uitgevoerd wordt voor soepele animatie
    const animate = () => {
      // Beweeg de cirkel geleidelijk naar de muis (X-as) met easing effect
      outlineX.current += (mouseX.current - outlineX.current) * 0.1;
      // Beweeg de cirkel geleidelijk naar de muis (Y-as) met easing effect
      outlineY.current += (mouseY.current - outlineY.current) * 0.1;

      // Zet de cirkel op de nieuwe positie
      if (cursorOutline.current) {
        // Zet de X positie van de cirkel
        cursorOutline.current.style.left = outlineX.current + 'px';
        // Zet de Y positie van de cirkel
        cursorOutline.current.style.top = outlineY.current + 'px';
      }

      // Vraag de browser om de volgende animatie frame
      animationFrameId = requestAnimationFrame(animate);
    };

    // Voeg een listener toe voor muisbewegingen
    window.addEventListener('mousemove', handleMouseMove);
    // Voeg listeners toe voor hover effecten op links
    window.addEventListener('mouseover', handleMouseOver);
    window.addEventListener('mouseout', handleMouseOut);
    // Start de animatie loop
    animationFrameId = requestAnimationFrame(animate);

    // Cleanup functie die uitgevoerd wordt wanneer de component wordt verwijderd
    return () => {
      // Verwijder de mousemove listener
      window.removeEventListener('mousemove', handleMouseMove);
      // Verwijder de mouseover listener
      window.removeEventListener('mouseover', handleMouseOver);
      // Verwijder de mouseout listener
      window.removeEventListener('mouseout', handleMouseOut);
      // Stop de animatie loop
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  // Rendeer de component
  return (
    <>
      {/* Dit is de paarse cirkel die achter de muis aanvolgt */}
      <div 
        className={`cursor-outline ${isHovering ? 'cursor-hover' : ''}`}
        ref={cursorOutline}
      ></div>
    </>
  );
};

// Exporteer de component
export default CustomCursor;
